import moment from "moment";
import { app } from "../App";
import { historyRef } from "../Router";
import {
  BULK_ITEMS_TEMPLATE,
  daysOfWeek,
  onlinePaymentMode,
} from "../constant";
import scss from "../styles/export.module.scss";
import { Timestamp } from "firebase/firestore";
import _ from "lodash";
import { getFirebaseToken } from "../services/utils/firebase_config";

export function getRoutePath(basePath, currPath) {
  if (currPath.startsWith("/")) return currPath;
  return (basePath.endsWith("/") ? basePath : basePath + "/") + currPath;
}

export function getCurrencySign() {
  return "£";
}

export const capitalize = (str) =>
  str
    .split(" ")
    .map((substr) => substr[0].toUpperCase() + substr.slice(1))
    .join(" ");

export const range = (start, end) => {
  const arr = [];
  for (let i = start; i <= end; ++i) arr.push(i);
  return arr;
};

export function dispatch(action) {
  return app?._store.dispatch(action);
}

export function history() {
  return historyRef.current;
}

export function arrayExtend(arr, count) {
  if (count <= arr.length) return [...arr];
  return [...arr, ...Array(count - arr.length).fill({})];
}

export function isDeepEqual(...args) {
  if (args.length < 2) return true;

  for (let i = 1; i < args.length; ++i) {
    if (JSON.stringify(args[i]) !== JSON.stringify(args[i - 1])) return false;
  }
  return true;
}

export function pickKeys(obj, keys) {
  const newObj = {};
  for (let key of keys) {
    newObj[key] = obj[key];
  }
  return newObj;
}

export const placeholderImg =
  "data:image/png;base64,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";

export function historyBack(fallbackUrl, delay = 500) {
  fallbackUrl = fallbackUrl || "/";
  const prevPage = window.location.href;

  window.history.go(-1);

  setTimeout(function () {
    if (window.location.href === prevPage) {
      window.location.href = fallbackUrl;
    }
  }, delay);
}

export const formatPhoneRemovePlus = (phoneNumber) => {
  if (!phoneNumber) return undefined;
  return phoneNumber.startsWith("+") ? phoneNumber.slice(1) : phoneNumber;
};

export const formatPhoneNumberAppendPlus = (phoneNumber) => {
  if (!phoneNumber) return undefined;
  return phoneNumber.startsWith("+") ? phoneNumber : `+${phoneNumber}`;
};

export const sassExports = (function () {
  let sass = {};
  for (let [key, val] of Object.entries(scss))
    sass[key] = JSON.parse(val.slice(1, -1));
  return sass;
})();

export function w(px) {
  return `calc(100vw / var(--base-width) * ${px})`;
}

export function h(px) {
  return `calc(100vh / var(--base-height) * ${px})`;
}

export const disabledDate = (d, minDate, maxDate) => {
  if (d == null) {
    return null;
  }

  return (
    (minDate != null && d.isBefore(minDate) && !d.isSame(minDate, "day")) ||
    (maxDate != null && d.isAfter(maxDate) && !d.isSame(maxDate, "day"))
  );
};

export const disabledTime = (d, minDate, maxDate) => {
  let hours = [],
    mins = [];
  if (d == null) {
    return null;
  }

  if (minDate && d.isSame(minDate, "day")) {
    hours = [
      minDate.hour() > 0
        ? { start: 0, end: minDate.hour() - 1 }
        : { start: 0, end: -1 },
    ];
    mins = [
      (hour) =>
        hour === minDate.hour() && minDate.minutes() > 0
          ? { start: 0, end: minDate.minutes() - 1 }
          : { start: 0, end: -1 },
    ];
  }

  if (maxDate && d.isSame(maxDate, "day")) {
    hours.push({ start: maxDate.hour() + 1, end: 24 });
    mins.push((hour) =>
      hour === maxDate.hour()
        ? { start: maxDate.minutes() + 1, end: 60 }
        : { start: 0, end: -1 },
    );
  }

  return {
    disabledHours: () => {
      return hours.reduce(
        (acc, curr) => acc.concat(range(curr.start, curr.end)),
        [],
      );
    },
    disabledMinutes: (hours) =>
      mins.reduce((acc, curr) => {
        const min = curr(hours);
        return acc.concat(range(min.start, min.end));
      }, []),
  };
};

export function pad(num, size) {
  if (num) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  }
  return "";
}

export function toFixedSafe(value, decimalPlaces = 2) {
  if (typeof value === "number") {
    return value.toFixed(decimalPlaces);
  }

  const numericValue = Number(value);

  if (!isNaN(numericValue)) {
    return numericValue.toFixed(decimalPlaces);
  }

  return "0.00";
}

export function getSubTotal(totalPrice, discount, gst, deliveryCharges) {
  const subTotal =
    Number(totalPrice) + Number(discount) - Number(deliveryCharges);
  return subTotal - Number(gst);
}

export const calculateItemPrice = (item) => {
  let totalPrice = 0;

  if (item?.variant && item?.variant?.price) {
    totalPrice += item.variant.price;
  }

  if (!item?.variant) {
    totalPrice += item?.price;
  }
  return totalPrice;
};

export const transformScheduleData = (values) => {
  const updatedValues = { ...values };

  Object.keys(updatedValues).forEach((day) => {
    if (updatedValues[day] === undefined) {
      delete updatedValues[day];
    } else {
      updatedValues[day] = updatedValues[day]?.map((slot) => ({
        startTime: moment(slot.startTime)
          .utc()
          .diff(moment(slot.startTime).startOf("day"), "seconds"),
        endTime: moment(slot.endTime)
          .utc()
          .diff(moment(slot.endTime).startOf("day"), "seconds"),
      }));
    }
  });

  return updatedValues || {};
};
export const convertToMoment = (seconds) => moment.utc(seconds * 1000);
export const momentToSeconds = (momentDate) => {
  return moment(momentDate)
    .utc()
    .diff(moment(momentDate).startOf("day"), "seconds");
};

export const transformScheduleDataForEdit = (schedule) => {
  if (!schedule) return;

  const transformedData = Object.keys(schedule).reduce((acc, day) => {
    acc[day] = schedule?.[day]?.map((slot) => ({
      startTime: convertToMoment(slot.startTime),
      endTime: convertToMoment(slot.endTime),
    }));
    return acc;
  }, {});

  return transformedData;
};

export function createWeeklySchedule(day, startTime, endTime) {
  const dayIndex = daysOfWeek.indexOf(day.toLowerCase());

  if (dayIndex === -1) {
    throw new Error("Invalid day passed. Please pass a valid day of the week.");
  }

  const schedule = {};
  daysOfWeek.forEach((d) => {
    schedule[d] = [];
  });

  let currentDayIndex = dayIndex;

  if (startTime > endTime) {
    for (let i = 0; i < daysOfWeek.length; i++) {
      const currentDay = daysOfWeek[currentDayIndex];
      schedule[currentDay].push({
        startTime: convertToMoment(startTime),
        endTime: convertToMoment(0),
      });

      currentDayIndex = (currentDayIndex + 1) % 7;
      const nextDay = daysOfWeek[currentDayIndex];
      schedule[nextDay].push({
        startTime: convertToMoment(0),
        endTime: convertToMoment(endTime),
      });

      currentDayIndex = (currentDayIndex + 1) % 7;
      if (currentDayIndex === dayIndex) break;
    }
  } else {
    for (let i = 0; i < daysOfWeek.length; i++) {
      const currentDay = daysOfWeek[currentDayIndex];

      schedule[currentDay].push({
        startTime: convertToMoment(startTime),
        endTime: convertToMoment(endTime),
      });

      currentDayIndex = (currentDayIndex + 1) % 7;
    }
  }

  return schedule;
}

export function calculateAverageRating(reviews) {
  if (reviews?.length === 0) return 0;

  const totalRating = reviews?.reduce((sum, review) => sum + review.rating, 0);
  const averageRating = totalRating / reviews.length;
  return averageRating.toFixed(1);
}

export function currentDayFilter(day = 1) {
  const currentDayOrder = new Date();
  currentDayOrder.setDate(currentDayOrder.getDate() - day);

  return Timestamp.fromDate(currentDayOrder);
}

export const findPaymentModeByKey = (payment_provider) => {
  const matchingKeys = onlinePaymentMode.some(
    (mode) => mode.key === payment_provider,
  );

  return matchingKeys[0];
};

export const createSecretPayload = (paymentMode, formData) => {
  switch (paymentMode) {
    case "stripeSecret":
      return {
        secretKey: formData.secretKey,
        publishableKey: formData.publishableKey,
      };
    case "payfastSecret":
      return {
        merchantId: formData.merchantId,
        securedKey: formData.securedKey,
      };
    default:
      return null;
  }
};

export const getLocation = (shop) => {
  return {
    address: shop?.address,
    city: shop?.city,
    lat: shop?.lat,
    lng: shop?.long,
  };
};

export const currencyFormat = (amount, currency) => {
  amount = Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  if (!currency) return amount;
  return `${amount} ${currency}`;
};
export const getAddonDifference = (currentAddons, newAddons) => {
  const currentById = _.keyBy(currentAddons, "id");

  const toAdd = [];
  const toUpdate = [];
  const toRemove = [];

  const seenIds = new Set();

  for (const addon of newAddons) {
    const { id } = addon;

    seenIds.add(id);

    if (!id) {
      toAdd.push(addon);
    } else if (!currentById[id]) {
      toAdd.push(addon);
    } else if (!_.isEqual(addon, currentById[id])) {
      toUpdate.push(
        _.pick(addon, [
          "id",
          "name",
          "price",
          "inventory_item_id",
          "quantity_used",
        ]),
      );
    }
  }

  for (const id of Object.keys(currentById)) {
    if (!seenIds.has(id)) {
      toRemove.push(id);
    }
  }

  return { toAdd, toUpdate, toRemove };
};

export const isNullish = (value) => {
  return [null, undefined, ""].includes(value);
};

export const downloadCsv = (csv, filename = "transactions.csv") => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const downloadExcelSheet = () => {
  const link = document.createElement("a");
  link.href = BULK_ITEMS_TEMPLATE;
  link.target = "_blank";
  link.click();
};

export const dataUriToBlob = (dataUri) => {
  const [header, base64String] = dataUri.split(",");
  const mimeMatch = header.match(/data:(.*?);base64/);

  if (!mimeMatch) {
    throw new Error("Invalid Data URI");
  }

  const mimeType = mimeMatch[1];
  const byteCharacters = atob(base64String);
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i += 512) {
    const slice = byteCharacters.slice(i, i + 512);
    const byteNumbers = new Array(slice.length);

    for (let j = 0; j < slice.length; j++) {
      byteNumbers[j] = slice.charCodeAt(j);
    }

    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: mimeType });
};

export const getFcmToken = async () => {
  try {
    const token = await getFirebaseToken({
      vapidKey: process.env.REACT_APP_VAPID_KEY,
      serviceWorkerRegistration: await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js",
      ),
    });

    if (!token) {
      console.warn("Firebase Messaging is not supported in this browser.");
      return null;
    }

    return token;
  } catch (e) {
    console.error("GET TOKEN ERROR", e);
    return null;
  }
};

export const tableLabel = (table) => {
  if (table?.tag_number == null) return "";
  const floor = Number(table.floor) || 0;
  return `${floor === 0 ? "G" : `F${floor}`}-T${table.tag_number}`;
};

export const getFloorLabel = (floor) => {
  if (floor === 0) return "Ground Floor";

  const suffix =
    floor % 100 >= 11 && floor % 100 <= 13
      ? "th"
      : ["th", "st", "nd", "rd"][floor % 10] || "th";

  return `${floor}${suffix} Floor`;
};

export const getSeatedDuration = (seatedAt) => {
  const diff = moment().diff(moment(seatedAt), "minutes");

  if (diff < 60) return `${diff}m`;
  return `${Math.floor(diff / 60)}h ${diff % 60}m`;
};
